import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api/api.service';
import {SpinnerService} from '../../services/spinner/spinner.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {ConfigService} from '../../services/config/config.service';
import {BreadcrumbsService} from '../../services/breadcrumbs/breadcrumbs.service';
import { Platform, PlatformModule } from '@angular/cdk/platform';

@Component({
  selector: 'app-download-page',
  templateUrl: './download-page.component.html',
  styleUrls: ['./download-page.component.scss'],
})
export class DownloadPageComponent implements OnInit {

  public breadcrumbLabelDetails = $localize`:details-page|breadcrumb-text-link@@details-page.breadcrumb-text:Dettagli`;
  public breadcrumbLabelDownload = $localize`:download-page|breadcrumb-text-link@@download-page.breadcrumb-text:Download`;

  link = '';

  data: any;
  flag = false;

  lastUrl = '';

  constructor(
    private spinner: SpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private conf: ConfigService,
    private breadcrumbService: BreadcrumbsService,
    private api:ApiService,
    private platform: Platform
  ) {
  }

  ngOnInit() {
    const sisCode = this.route.snapshot.paramMap.get('sis_code');
    const aic6 = this.route.snapshot.paramMap.get('aic6');
    const tipo = this.route.snapshot.paramMap.get('type');
    this.flag=false;
    this.spinner.show();

    console.log("Webkit", this.platform.WEBKIT);
    console.log("Blink", this.platform.BLINK);
    
    // const tmp = false
    if(this.platform.WEBKIT) { //this.platform.WEBKIT
      this.api
      .download(sisCode,aic6,tipo).subscribe({
        next: (res) => {
          this.flag=false;
          
          const disposition = res.headers.get('Content-Disposition') || null;
          const filename: string | null = disposition?.split('filename=')[1] || null
          
          const url = window.URL.createObjectURL(res.body || new MediaSource());
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename || 'file.pdf';
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        },
        error: (error) => {
          console.log("status errore stampato non trovato" + error.status);
          this.flag=true
        },
        complete: ()=> {
          this.spinner.hide()
        }
      })
    } else {
      this.data = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${
        this.conf.getConfig().baseUrl
      }organizzazione/${sisCode}/farmaci/${aic6}/stampati?ts=${tipo}`
    );
      this.spinner.hide()
    }
    
    this.route.queryParams
      .subscribe(params => {

        // Otteniamo il percorso del link
        const urlTree = this.router.createUrlTree([], {relativeTo: this.route, queryParams: params});
        const url = this.router.serializeUrl(urlTree);

        // Aggiungo la url attuale all'array
        this.lastUrl=this.breadcrumbService.getLast()?.routerLink==undefined?'':this.breadcrumbService.getLast()?.routerLink;
        this.breadcrumbService.pushUrl({label: this.breadcrumbLabelDownload, routerLink: url});
      });
  }


}
